import React, { Component } from "react";
import PropTypes from "prop-types";
import { graphql } from "react-apollo";
import { mutationDeleteFieldFromCustomer } from "Apollo";
import { ShowNotice } from "Store";
import Icon from "module-common/Icon";

export default graphql(mutationDeleteFieldFromCustomer)(
  class DeleteButton extends Component {
    static propTypes = {
      customerId: PropTypes.number,
      fieldId: PropTypes.number
    };

    render() {
      return (
        <Icon name="x-button-gray" onClick={this.onClick} {...this.props} />
      );
    }

    onClick = async () => {
      const { customerId, fieldId, refetch, mutate } = this.props;
      try {
        await mutate({
          variables: {
            customerInput: { id: customerId },
            customerFieldInput: { id: fieldId }
          },
          refetchQueries: ["getCustomerDetail", "getCustomerJourney"]
        });
      } catch (error) {
        ShowNotice("customer-field-delete-error");
      }
    };
  }
);



// WEBPACK FOOTER //
// ./src/module-customer-journey/detail/DeleteButtonWithMutation.js